// extracted by mini-css-extract-plugin
export default {"add":"Stack_add__Ll4vE","require":"Stack_require__cZ0rt"};